// 搜索历史记录

import { useEffect, useState } from "react"

interface SuggestionItem {
	id: string
	label: string
}

const MAX_HISTORY_ITEMS = 5
const STORAGE_KEY = "searchHistory"

export function useSearchHistory() {
	const [searchHistory, setSearchHistory] = useState<SuggestionItem[]>([])

	// 读取历史记录
	const loadHistory = () => {
		try {
			const history = localStorage.getItem(STORAGE_KEY)
			if (history) {
				const parsedHistory = JSON.parse(history)
				if (Array.isArray(parsedHistory)) {
					// 验证数据格式并过滤无效项
					const validHistory = parsedHistory.filter(
						(item) =>
							typeof item === "object" &&
							item !== null &&
							typeof item.id === "string" &&
							typeof item.label === "string",
					)
					setSearchHistory(validHistory)
				}
			}
		} catch (e) {
			console.error("解析搜索历史失败:", e)
			setSearchHistory([])
			localStorage.removeItem(STORAGE_KEY)
		}
	}

	// 添加新的搜索记录
	const addHistory = (term: string) => {
		try {
			const trimmedTerm = term.trim()
			if (!trimmedTerm) return

			// 从 localStorage 读取最新数据
			const history = localStorage.getItem(STORAGE_KEY)
			let currentHistory: SuggestionItem[] = []

			if (history) {
				try {
					const parsedHistory = JSON.parse(history)
					if (Array.isArray(parsedHistory)) {
						currentHistory = parsedHistory.filter(
							(item) =>
								typeof item === "object" &&
								item !== null &&
								typeof item.id === "string" &&
								typeof item.label === "string",
						)
					}
				} catch (e) {
					console.error("解析搜索历史失败:", e)
				}
			}

			const newItem = { id: Date.now().toString(), label: trimmedTerm }
			const newHistory = [
				newItem,
				...currentHistory.filter((item) => item.label !== trimmedTerm),
			].slice(0, MAX_HISTORY_ITEMS)

			setSearchHistory(newHistory)
			localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory))
		} catch (e) {
			console.error("添加搜索历史失败:", e)
		}
	}

	// 清除历史记录
	const clearHistory = () => {
		try {
			setSearchHistory([])
			localStorage.removeItem(STORAGE_KEY)
		} catch (e) {
			console.error("清除搜索历史失败:", e)
		}
	}

	// 监听 localStorage 变化
	useEffect(() => {
		const handleStorageChange = (e: StorageEvent) => {
			if (e.key === STORAGE_KEY) {
				loadHistory()
			}
		}

		window.addEventListener("storage", handleStorageChange)
		loadHistory() // 初始加载

		return () => {
			window.removeEventListener("storage", handleStorageChange)
		}
	}, [])

	return {
		searchHistory,
		addHistory,
		clearHistory,
		loadHistory,
	}
}
